import React, { useState, useRef, useEffect } from "react";
import WmModals from "../modals/Wm.Modals";
import API_ENDPOINT from "../wm.api.service";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Required from "../Components/required/Required"
import edu from "../assets/images/icons/color-02.svg";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch"
import { hideCertForPublic } from '../functions/apis'
import { wordCountFun } from '../functions/general'
import dummy from "../assets/images/file.svg";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import { useMutation,useQueryClient, } from "react-query";
import { ExclamationIcon } from "@heroicons/react/outline";
import Spinner from "../Components/spinner/Spinner";
import { getSinglePortfolioDetail, updateCertificationData } from "../functions/details";
import Moment from "react-moment";
const Cookie = new Cookies();
function Certificatecard({ certData }) {
  const queryClient = useQueryClient()
  var token = Cookie.get("wmtoken");
  const [editModal, setEditModal] = React.useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const [portfolioData, setPortfolioData] = useState({identity:'',title: '', date: '', description: '', mediaSend: '', media: dummy,label:'',isShowCert:false });
  const bioWordCount = (words) => {
    setWordCount(words?.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {
      setCountBool(true);
    }
    if (!wordCountFun(words, maxLength)) {
      setCountBool(false);
    }
  };
  useEffect(() => {
    bioWordCount(portfolioData.description)
  }, [])
  const fileUpload = useRef(null);
  function handleImageClick() {
    fileUpload.current.click();
  }
  const uploadImage = (e) => {
    e.persist();
    var file = e.target.files[0];
    setPortfolioData((prevData) => {
      prevData.media = URL.createObjectURL(file)
      prevData.mediaSend = file
      return { ...prevData }
    })
  };
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteFeild = (e, id) => {
    setIsDeleting(true);
    e.preventDefault();
    var fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("field_name", "CERT");
    fd.append("field_id", id);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
      data: fd,
    })
      .then(function (response) {
        queryClient.invalidateQueries('certificationData')
        setIsDeleting(false);
        setEditModal(false);
        setIsDeleteModalOpen(false);
      })
      .catch(function (err) {
        console.log(err);
        alert(err.response.data.message);
      });
  };
  const [deleteModal, setIsDeleteModalOpen] = useState(false);
  const updateView = () => {
    hideCertForPublic(portfolioData.identity, portfolioData.isShowCert, portfolioData.label, portfolioData.description)
      .then(function () {
        queryClient.invalidateQueries('certificationData')
        setEditModal(false);
      })
      .catch(function (err) {
      })
  }
  const fetchSingleData = useMutation((documentId,isVerified) => getSinglePortfolioDetail('CERT', documentId,'PROFILE',isVerified), {
    onSuccess: (data) => {
      setPortfolioData({
        identity: data.identity, title: data.title, date: data.date, description: data.description, mediaSend: data.certificate_url && data.certificate_url, media: data.certificate_url, label: data.user_label, isShowCert:'' 
      })
      setEditModal(true);
      console.log(data)
    }
  })
  const updateCertificate = useMutation((data) => updateCertificationData(data), {
    onMutate: async () => {
      await queryClient.cancelQueries('certificationData')
      const previousValue = queryClient.getQueriesData('certificationData')
      return previousValue
    },
    onError: (err, previousValue) => {
      queryClient.setQueryData('certificationData', previousValue)
    },
    onSuccess: () => {
      queryClient.invalidateQueries('certificationData')
      setEditModal(false)
    }
  })
  return (
    <React.Fragment>
      {fetchSingleData.isLoading ? "Fetching Data....." : 
        <div className="educationCard space-y-1 shadow relative p-6 cursor-pointer" onClick={(e) => fetchSingleData.mutate(certData.identity,certData.isVerified)}>
          <div className="flex justify-between">
            <span className="text-base md:text-xl text-gray-700 inline-block capitalize" style={{"color":"var(--color-5)"}}>{certData.title}</span>
            <span className="text-xs italic text-gray-600 manpro">Certfificate issued year <Moment format={"YYYY"}>{certData.start_date}</Moment></span>
          </div>
          <div className="justify-between">
            <p className="wm-m-none font-semibold text-sm md:text-sm text-gray-700 manpro leading-6">{certData.description}</p>
          </div>
          <div className="flex justify-end">
            {certData.isVerified === 1 ? (
              <div md={12} className="media_wrapper">
                <div className="inline-block border rounded-md w-16 h-16 overflow-hidden">
                  <a href={certData.certificate_url} target="_blank">
                    <img src={edu} alt="edu" className="w-full h-full object-cover" style={{ filter: "contrast(0)" }}/>
                  </a>
                </div>
              </div>
            ) : certData.certificate_url ? (
              <div md={12} className="media_wrapper">
                <div className="inline-block border rounded-md w-16 h-16 overflow-hidden">
                  <img src={certData.certificate_url} alt="edu" className="w-full h-full object-cover" />
                </div>
              </div>
            ) : (
              <div md={12} className="media_wrapper">
                <div className="inline-block border rounded-md w-16 h-16 overflow-hidden">
                  <img src={edu} alt="edu" className="w-full h-full object-cover" style={{ filter: "contrast(0)" }}/>
                </div>
              </div>
            )}
          </div>
        </div>}
      <WmModals show={editModal} onHide={() => setEditModal(false)} size="lg" className="edu-modal">
        <h5 className="mb-4">Edit Certificate Detail</h5>
        <form onSubmit={(e) => { e.preventDefault(); updateCertificate.mutate(portfolioData) }}>
          <div className="wm_form_group flex flex-col mb-4">
            <label className="wm_form_label">Certificate Title <Required /></label>
            <input type="text" name="institute" placeholder="Certificate Title" className="wm_form_input border-bottom border-gray-300" required disabled={certData.isVerified === 1 && true} value={portfolioData.title} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.title = e.target.value; return { ...prevData } }) }}/>
          </div>
          <Row>
            <Col md={6}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Date Recived <Required /></label>
                <input type="date" name="end_date" className="wm_form_input border-bottom border-gray-300" disabled={certData.isVerified === 1 && true} required value={portfolioData.date} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.date = e.target.value; return { ...prevData } }) }}/>
              </div>
            </Col>
            <Col md={12}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Description</label>
                <textarea name="description" placeholder="Description" value={portfolioData.description} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.description = e.target.value; return { ...prevData } }) }} className="wm_form_input border-bottom border-gray-300" onKeyUp={(e) => bioWordCount(e.target.value)} maxLength="150"></textarea>
                <small className={`mt-2 ${countBool ? "text-red-500" : "text-gray-400"}`}>{wordCount}/150</small>
              </div>
            </Col>
            {certData.isVerified === 1 && <Col md={12}>
              <div className="wm_form_group flex flex-col mb-4">
                <label className="wm_form_label">Label</label>
                <input type="text" name="Label" className="wm_form_input border-bottom border-gray-300" value={portfolioData.label} onChange={(e) => { e.persist(); setPortfolioData((prevData) => { prevData.label = e.target.value; return { ...prevData } }) }}/>
              </div>
            </Col>}
            {certData.isVerified === 1 ? '' : <><Col md={7}>
              <div className="wm_form_group flex mb-4 items-center">
                <div className="flex flex-col mr-4">
                  <label className="wm_form_label">Media <Required /></label>
                  <input type="file" className="hidden" onChange={(e) => uploadImage(e)} ref={fileUpload} accept="image/png, image/jpeg, image/jpg"/>
                  <div onClick={handleImageClick} className="fileImageWrapper w-40 h-28 flex justify-center items-center rounded-xl border-gray-300 border-2 border-dashed cursor-pointer overflow-hidden">
                    {portfolioData.media && portfolioData.media !== "DELETE" ? <img className="object-cover" src={portfolioData.media} alt="education"/>: <img className="object-cover" src={dummy} alt="education"/>}
                  </div>
                </div>
              </div>
            </Col></>}
            <Col md={12} className='mb-3'>
              {certData.isVerified === 1 && <div className="wm_form_group flex flex-col mr-4">
                <label className="wm_form_label">Show Certificate</label>
                <Wmswitch color="success" className='mb-0' checked={portfolioData.isShowCert} onChange={() => setPortfolioData((prevData) => { prevData.isShowCert = !portfolioData.isShowCert; return { ...prevData } })} />
              </div>}
            </Col>
          </Row>
          <div className="wm_form_group flex">
            {certData.isVerified === 1 ? <Wmbutton label={updateCertificate.isLoading ? <CircularProgress className="loader_size_xsm" /> : "update"} bordered className="rounded w-20 mr-2" type="button" color="primary-border" onClick={(e) => updateView(e)}/> : 
            <Wmbutton label={updateCertificate.isLoading ? (<CircularProgress className="loader_size_xsm" />) : ("Update")} bordered className="rounded w-20 mr-2" type="submit" color="primary-border"/>}
            {certData.isVerified === 1 ? '' : <Wmbutton label="Delete" onClick={(e) => {setIsDeleteModalOpen(true);setEditModal(false);}} className="rounded w-20 mr-2" type="button" color="danger"/>}
            <Wmbutton label="Cancel" onClick={() => setEditModal(false)} className="rounded w-20 mr-2" type="button" color="primary"/>
          </div>
        </form>
      </WmModals>
      <WmModals show={deleteModal} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
        <div className='px-10 py-4'>
          <div>
            <p className='text-center text-xl font-semibold text-gray-700 manpro'>Delete Certificate?</p>
            <div className=' bg-red-100 rounded border-l-2 border-red-700 my-10'>
              <div className='flex space-x-3 p-4'>
                <div>
                  <ExclamationIcon className='w-6 text-red-600' />
                </div>
                <div>
                  <p className='manpro text-red-800 mb-0 font-semibold'>Warning</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>Are you sure you want to delete?</p>
                  <p className='manpro text-red-700 mb-0 text-sm'>You can't undo this action.</p>
                </div>
              </div>
            </div>
            <div className='text-center space-x-3 flex justify-center'>
              <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => { setIsDeleteModalOpen(false); setEditModal(true); }}>Cancel</button>
              {isDeleting ? <div className='relative flex items-center justify-center'><Spinner className="" width={20} height={20} /></div> : <button className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={(e) => { deleteFeild(e, certData.identity); }}>Delete certificate</button>}
            </div>
          </div>
        </div>
      </WmModals>
    </React.Fragment>
  );
}

export default Certificatecard;
